import React from 'react';
import '../css/FomoAlert.css';

const FomoAlert = ({ 
  isOpen, 
  onClose, 
  featureName,
  customMessage = null,
  showPaymentButton = true 
}) => {
  if (!isOpen) return null;

  const defaultMessage = `Probably want to complete registration first, then maybe you'll be allowed to access ${featureName}. Just saying... 🤷‍♂️`;

  const handlePaymentClick = () => {
    // Trigger the payment modal or redirect to payment
    // For now, we'll just close the alert
    onClose();
    // TODO: Integrate with existing payment flow from RequestAccessModal
  };

  return (
    <div className="fomo-alert-overlay" onClick={onClose}>
      <div className="fomo-alert-modal" onClick={(e) => e.stopPropagation()}>
        <div className="fomo-alert-header">
          <h3>🔒 Premium Feature</h3>
          <button className="fomo-alert-close" onClick={onClose}>×</button>
        </div>
        
        <div className="fomo-alert-content">
          <div className="fomo-alert-icon">
            <span className="fomo-emoji">😅</span>
          </div>
          
          <p className="fomo-alert-message">
            {customMessage || defaultMessage}
          </p>
          
          <div className="fomo-alert-benefits">
            <h4>What you're missing out on:</h4>
            <ul>
              <li>✨ Full {featureName} access</li>
              <li>🚀 Advanced AI features</li>
              <li>📊 Premium analytics</li>
              <li>🔧 Advanced settings</li>
              <li>💬 Priority support</li>
            </ul>
          </div>
        </div>
        
        <div className="fomo-alert-actions">
          {showPaymentButton && (
            <button 
              className="fomo-alert-upgrade-btn"
              onClick={handlePaymentClick}
            >
              🎯 Complete Registration
            </button>
          )}
          <button 
            className="fomo-alert-cancel-btn"
            onClick={onClose}
          >
            Maybe Later
          </button>
        </div>
        
        <div className="fomo-alert-footer">
          <p className="fomo-alert-hint">
            💡 Hint: Other users who completed registration are already enjoying these features...
          </p>
        </div>
      </div>
    </div>
  );
};

export default FomoAlert;
